import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_MODULE } from '../../../../Constants';

export const useCreateModule = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const createCourseModuleHook = async (module, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_MODULE}`,
        {module: {...module, uuid: uuidv4()}}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to create module");
      }
    } catch (error) {
      setError("An error occurred while creating module");
    } finally {
      setLoading(false);
    }
  };

  return [ createCourseModuleHook, loading, error, success ];
};